
import { Component } from '@theme/component';

class NotifyMe extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (window.matchMedia('(hover: hover)').matches) return;

    this.copertura = this.querySelector('[data-notify-cover]');
    if (!this.copertura) return;

    this.copertura.addEventListener('click', this.#apri);
  }

  #apri = () => {
    if (this.classList.contains('is-open')) return;
    this.classList.add('is-open');
    this.querySelector('input[type="email"]')?.focus();
  };
}

if (!customElements.get('notify-me-component')) customElements.define('notify-me-component', NotifyMe);

const gancioVisibile = () =>
  [...document.querySelectorAll('form.pdp-soldout__hook')].find((form) => form.offsetParent !== null);

function rimettiBottoneApp() {
  const portale = document.querySelector('.nm-portal');
  const gancio = gancioVisibile();
  if (portale && gancio && portale.parentElement !== gancio) gancio.appendChild(portale);
}

new MutationObserver(rimettiBottoneApp).observe(document.body, { childList: true, subtree: true });

window.matchMedia('(max-width: 767px)').addEventListener('change', rimettiBottoneApp);

rimettiBottoneApp();
